/** Keys used with `localStorage` / `sessionStorage` in this app (not HTTP cookies). */
export const keys = {
  LANGUAGE: "clicknpark_language",
  RELEASE_NOTES_STATE: "clicknpark_release_notes_state",
  THEME: "clicknpark_theme",
} as const;

export type StorageKey = (typeof keys)[keyof typeof keys];
